import { TOAST } from '@commoncore/constants/ToastMessages';
import { HTML_ERRORS } from '@commoncore/constants/htmlErrors';
import { SessionStorageProps } from '@commoncore/enums/sessionStorageProps';
import { MultiSelectLibrary } from '@commoncore/utils/MultiSelectUtil';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';

import { AlbumsImplementation } from '@mainrepo/app/core/implementation/AlbumsImplementation';
import { GlobalClassInstance } from '../constants/GlobalClass';
import { BANNER_CONSTANTS } from '../constants/bannerConstants';
import { IndexDBImplementation } from './IndexDBImplementation';
import { ListViewImplementation } from './ListViewImplementation';
import { MemoryImplementation } from './MemoryImplementation';
import { PreviewImplementation } from './PreviewImplementation';
export class FileOperationsImplementation {
  public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  private rootFolderCheck:boolean = false;
  public multiSelect: any;
  public doubleClicked: boolean = false;
  // public parentFolderKey: string = USER_DETAILS.rootFolderKey;
  public folderKeys: any = [USER_DETAILS["USER_DETAILS"]["rootFolderKey"]];
  public folderNames: any = [{"objectName":"All Files"}]
  public listService: any;
  public enableButton:boolean = false;
  public folderName: string="";
  public albumName:string = "";
  contextMenuService: any;
  customMetadata: any;
  listImpl:any;
  loggerService: any;
  public previewImplementation: any;
  public memoryImplementation
  folderService:any;
  cleverTapEventsService: any;
  public months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  public weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  public changeDetector:any;
  static singleInstance:FileOperationsImplementation;
  public previousTab: string;
  localStorageService:any;
  customSort
  myAlbumsDBStoreName = "MyAlbumsList";
  private db: IndexedDBModule;
  private dataArray:any=[];
  private indexDBdata:any="";
  cacheImpl:IndexDBImplementation;
  albumsImpl:AlbumsImplementation;
  sessionStorageService: any;
  
  constructor(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
  }

  public static getInstance(globalService):FileOperationsImplementation{
		if(this.singleInstance == null){
			this.singleInstance = new FileOperationsImplementation(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
  }

  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.route = globalService.getActivatedRoute();
    this.multiSelect = MultiSelectLibrary.getInstance(globalService);
    this.listService = globalService.getListServiceRef();
    this.listImpl = ListViewImplementation.getInstance(globalService)
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.previewImplementation = PreviewImplementation.getInstance(globalService)
    this.memoryImplementation = MemoryImplementation.getInstance(globalService)
    this.folderService = globalService.getFolderServiceRef();
    this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
    this.customSort = globalService.getcustomSortRef();
    this.db = IndexedDBModule.getInstance(globalService);
    this.cacheImpl = IndexDBImplementation.getInstance(globalService);
    this.albumsImpl = AlbumsImplementation.getInstance(globalService);
  }

  public setPayloadForFileOperations(files,operation,correlationId){

    var objectsArray = [];
    var payload = []
      if (Array.isArray(files)) {
        objectsArray = files
      } else {
        objectsArray.push(files)
      }
      objectsArray.map(obj=>{
        var object;
        if(obj["FullObject"]){
          object = obj["FullObject"]
        }else{
          object = obj
        }
        payload.push({
          "correlationId":correlationId,
          "object":object,
          "operation":operation
        })
      })
    return payload;
  }

  public setPayloadForCollabShareFileOperations(files, operation){
    var file = files["FullObject"]?files["FullObject"]:files
    var payload;
    switch(operation){
      case "TRASH":
        payload = [];
        var objectsArray = [];
        if (Array.isArray(files)) {
          objectsArray = files
        } else {
          objectsArray.push(files)
        }
        objectsArray.map(obj=>{
          var object;
          if(obj["FullObject"]){
            object = obj["FullObject"]
          }else{
            object = obj
          }
          payload.push({
            "shareKey":object.shareKey,
            "parentObjectKey":object.parentObjectKey,
            "objectKey":object.objectKey
          })
        })
        return payload;
      case "RENAME":
        payload = {
          "status": file.status,
          "parentObjectKey": file.parentObjectKey,
          "objectKey": file.objectKey,
          "objectName": file.objectName,
          "sourceName": file.sourceName
        }
        return payload;
      }
    
  }
  public setPayloadForAlbumFileOperations(files,operation,keyWordForPerformingTheOperation){
    var objectsArray = [];
    var lastPart = ""
    var payload = []
    if (Array.isArray(files)) {
      objectsArray = files
    } else {
      objectsArray.push(files)
    }
    objectsArray.map(obj=>{
      var objmetadata = {};
      var object;
      if(obj["FullObject"]){
        object = obj["FullObject"]
      }else{
        object = obj
      }
      if(operation == "FRN"){
        lastPart = this.universalService.currentAlbum?this.universalService.currentAlbum["boardName"]:object["boardName"]
        objmetadata["objectName"] = object["objectName"] 
      }else{
        lastPart = object["objectKey"]
      }
      objmetadata["boardKey"] = this.universalService.currentAlbum?this.universalService.currentAlbum["boardKey"]:object["boardKey"]
      objmetadata["objectKey"] = object["objectKey"]
      payload.push({
        "correlationId":object["boardKey"] + keyWordForPerformingTheOperation + lastPart,
        "object":objmetadata,
        "operation":operation
      })
    })
    return payload;
  }

  public setPayloadForTeamFolderObjectOperations(files,operation){
    var objectsArray = [];
    var payload = {};
    var self = this;
    var currentTF = this.universalService.currentTeamFolder;
    if (Array.isArray(files)) {
      objectsArray = files
    } else {
      objectsArray.push(files)
    }
    if(operation == "RENAME") {
      objectsArray.map(obj=>{
        var object;
        if(obj["FullObject"]){
          object = obj["FullObject"]
        }else{
          object = obj
        }
        payload = {
          "tfKey": (object.tfKey != undefined ?object.tfKey :currentTF.tfKey),
          "objectName":object.objectName,
          "parentObjectKey":object.parentObjectKey,
          "objectKey":object.objectKey
        };
      });
    } else if(operation == "TRASH") {
      var objectsVal;
      var objToTrash = [];
      objectsArray.map(obj=>{
        var object;
        if(obj["FullObject"]){
          object = obj["FullObject"]
        }else{
          object = obj
        }
        objectsVal = {
          "parentObjectKey":object.parentObjectKey,
          "objectKey":object.objectKey
        }
        objToTrash.push(objectsVal);
      });
      payload = {
        "tfKey":self.universalService.currentTeamFolder.tfKey,
        "objects":objToTrash
      };
    }
    
    return payload;
  }

  public setPayloadForAlbumOperations(files,operation,keyWordForPerformingTheOperation){
    var payload = []
    payload.push({
      "correlationId":files.boardKey + keyWordForPerformingTheOperation + files.boardName,
      "object":files,
      "operation":operation
    })
      
    return payload;
  }

  setRequiredDataForAdding(files,tabName="") { // common
    if(tabName != "PrivateFolder"){
      this.folderKeys = [USER_DETAILS["USER_DETAILS"]["rootFolderKey"]];
      this.folderNames = [{"objectName":"All Files"}];
    }
    this.listService.parentFolderKey = this.folderKeys[this.folderKeys.length - 1];
    if (Array.isArray(files)) {
      this.universalService.filesToBeAdded = files
    } else {
      this.universalService.filesToBeAdded.push(files)
    }
    this.contextMenuService.hideCustomContextMenu();
    var array = [];
    if (this.universalService.inAppWebViewOpened && this.universalService.currentTab == "copy") {
      this.universalService.objectsToBeAdded = this.universalService.filesToBeAdded;
      return;
    }

    for (var i = 0; i < this.universalService.filesToBeAdded.length; i++) {
      if(this.router.url.includes('/teamfolder')) {
        if (this.universalService.filesToBeAdded[i]["FullObject"]) {
          array.push({
            "objectKey":this.universalService.filesToBeAdded[i]["FullObject"]["objectKey"],
            "tfKey":this.universalService.filesToBeAdded[i]["FullObject"]["tfKey"]
          });
        } else {
          array.push({
            "objectKey":this.universalService.filesToBeAdded[i]["objectKey"],
            "tfKey":this.universalService.filesToBeAdded[i]["tfKey"]
          });
        }
      } else {
        if (this.universalService.filesToBeAdded[i]["FullObject"]) {
          array.push(
            this.universalService.filesToBeAdded[i]["FullObject"]["objectKey"]
          )
        } else {
          array.push(
            this.universalService.filesToBeAdded[i]["objectKey"]
          )
        }
      }
    }
    this.universalService.objectsToBeAdded = array;
  }


  getFolders(foldersUrl) { //common
    var self = this;
    return new Promise((resolve,reject)=>{
    this.http.get(foldersUrl).subscribe(
        async suc => {
          if(this.universalService.popUpToBeOpened == "movePopUp" || this.universalService.popUpToBeOpened == "copyPopUp"){
            if(this.universalService.popUpToBeOpened == "movePopUp"){
    
              this.universalService.selectedNodes.forEach(node => {
                const selectedObject = node["FullObject"] ? node["FullObject"] : node;
                var index = suc["objects"].findIndex(obj => obj["objectKey"] == selectedObject["objectKey"]);
                if (index >= 0) {                          // for not showing the selected folder or file in the move/copy section
                  suc["objects"].splice(index, 1)
                }
              });
            }
            var allData = this.customMetadata.segregateData(suc,'allfiles');
            await this.listImpl.getFoldersForMoveCopy(allData);
            resolve(true)
          }else{
            await this.listImpl.getFolders(suc);
            resolve(true)
          }
        
        },
        err => {
          AppEvents.optionSelected.next({addToJC: false});
          this.universalService.popUpToBeOpened = "";
          this.universalService.showErrorMessage(err);
          this.universalService.isServerError = false;
          reject (err);
        }
      )
    })
  }


  getAlbums(albumsUrl) {  // common
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(albumsUrl).subscribe(
        async suc => {
          var albums ;
          albums = self.listImpl.getAlbums(suc);
          
          albums.map(album => {
            if(album["FullObject"]["boardMembers"]){
              album["FullObject"]["boardMembers"].map(member=>{
                if(member["profilePic"]) {
                  let type = self.universalService.checkIfImgTypeParamIsRequired("");
                  let profilePicUrl = member["profilePic"].includes('?') ? member["profilePic"] + '&': member["profilePic"] + '?';
                  member["profilePic"] = profilePicUrl + 'size=a&apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
                }
              })
            }
          })
          albums = self.sortAlbumsList(albums)
          resolve(albums) ;
        },
        err => {
          self.universalService.showErrorMessage(err);
          reject(err);
        }
      )
    })
  }

  sortAlbumsList(albumsList){
    return this.customSort.sortListViewFilesByAttribute(albumsList, 'Descending', 'lastModifiedDate');

  }


  
  addToRepoApi(url, params, addedFoldername, objectKey) { //common
    this.http.post(url, params).subscribe(
      suc => {
        this.universalService.filesToBeAdded = [];
        this.addToRepo(suc, addedFoldername, objectKey)
      },
      err => {
        this.universalService.showLoader = false;
        if( err.error.code== "TEJUM0409"){
          AppEvents.optionSelected.next({addToJC: false});
          window.scrollTo(0, 0);
          this.universalService.showToast(TOAST["QUOTA_EXHAUSTED"],'error');
          BANNER_CONSTANTS.STORAGE_BANNER["forceShow"] = true;
          AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);
        }else{
          this.universalService.showErrorMessage(err);
        }
        this.universalService.isServerError = false;
      }
    )
  }

  async addToRepo(response, addedFoldername, objectKey) { //commo
    this.universalService.showLoader = false;
    this.universalService.objectSelected = false;
    this.listImpl.indexsArray = [];
    var msg ="";
    var userData = this.localStorageService.getUserData(true);
    if(this.universalService.inAppWebViewOpened)
      this.universalService.currentTab = "";
    if ((response["processed"] == this.universalService.objectsToBeAdded.length && response["unprocessed"].length == 0) ) {
  
      if(response["operation"]=="COPY"){
        this.universalService.showToast(TOAST["COPY_SUCCESS"], "success");
        //this.cacheImpl.addBulkFileIndexDB(r);
        await this.addToDBForMoveCopy(response, "COPY");
      } else{
        this.universalService.showToast(this.universalService.objectsToBeAdded.length + " item added to " + addedFoldername, "success");
        this.universalService.viewButtonUrl = '/allfiles/' + objectKey
        this.universalService.showViewButton = true;
      } 
      setTimeout(() => {
        this.universalService.disableModalBackdrop();
        this.listService.deSelectAll(null);
      }, 1000)
    } else {
      if(response["operation"]=="COPY"){
        const totalCopied = response["objects"].length;
        const totalFailedToCopied = response["unprocessed"] ? response["unprocessed"].length : 0;
        if(userData && userData["quota"]){
          response["usedSpace"] = response["usedSpace"] == 0 ? 0 : (response["usedSpace"] ? response["usedSpace"] : userData["quota"]["totalUsedQuota"]);
          userData["quota"]["totalUsedQuota"] = response["usedSpace"];
          
          AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,updateStorageRepresentationOnUI:true});
        }
        if(response.unprocessed!=undefined && response.unprocessed.length>0 && response.uploadDisAllowedResaon!= undefined && response.uploadDisAllowedResaon.errorMessage) {
          if(response.uploadDisAllowedResaon.errorCode == "TFLQU1009") {
            this.universalService.showToast(TOAST["TF_COPY_QUOTA_FULL"], "error");
          } else {
            this.universalService.showToast(response.uploadDisAllowedResaon.errorMessage, "error");
          }
        } else if(response.unprocessed!=undefined && response.unprocessed.length>0){
          if(response.uploadDisAllowedReason && response.uploadDisAllowedReason.errorCode && response.uploadDisAllowedReason.errorCode == "TEJSO1009") { //Handled as per 637567
            this.universalService.showToast(TOAST["COPY_FAILURE_STORAGE_FULL"], "error");
          } else if(totalFailedToCopied >0 && totalCopied ==0){
            this.universalService.showToast(TOAST["COPY_FAILURE"], "error");
          } else if(totalFailedToCopied >0 && totalCopied > 0){
            this.universalService.showToast(TOAST["PARTIAL_COPY"], "error");
          } else {
            this.universalService.showToast(TOAST["COPY_SUCCESS"], "success");
          }
          BANNER_CONSTANTS.STORAGE_BANNER["forceShow"] = true;
          AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);
        }
        else {
          this.universalService.showToast(TOAST["COPY_SUCCESS"], "success")
          BANNER_CONSTANTS.STORAGE_BANNER["forceShow"] = true;
          AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);
        }
        //Insert in DB 
        await this.addToDBForMoveCopy(response, "COPY");
      } else{
        if(this.universalService.popUpToBeOpened == "addToJioCloud"){
          this.universalService.showToast(response["processed"] + ' out of ' + this.universalService.objectsToBeAdded.length + ' file(s) are added successfully', "success")
        }
        else{
          this.universalService.showToast(response["processed"] + ' out of ' + this.universalService.objectsToBeAdded.length + ' file(s) are uploaded successfully', "warning")
        }
      }
      setTimeout(() => {
        this.universalService.disableModalBackdrop();
        if(this.universalService.inAppWebViewOpened){
          this.universalService.currentTab == "";
        }
        this.listService.deSelectAll(msg); // passing the msg in this function, for in app webview client needs to show the toast message.
      }, 1000)
    }
    //update used space post copy
    if(response.usedSpace) {
      response["usedSpace"] = response["usedSpace"] == 0 ? 0 : (response["usedSpace"] ? response["usedSpace"] : userData["quota"]["totalUsedQuota"]);
      userData["quota"]["totalUsedQuota"] = response["usedSpace"];

      AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,updateStorageRepresentationOnUI:true});
    }
  }

  addtoAlbumApi(url, params) { //common
   return new Promise((resolve, reject)=>{
      this.http.post(url, params).subscribe(
        suc => {
          this.universalService.filesToBeAdded = [];
          this.addToAlbum(suc);
          this.cleverTapEventsService.addToAlbumSuc(this.universalService.currentTab)
          resolve(true)
        },
        err => {
          this.universalService.disableModalBackdrop();
          this.universalService.showLoader = false;
          this.loggerService.log("error is",err);
          if (err["error"]['code'] == "SSOM0429") {
            this.universalService.showToast(TOAST["FILE_EXISTS_ON_ALBUM"],"error")
          } else {
            this.universalService.showErrorMessage(err);
            this.universalService.isServerError = false;
          }
          this.universalService.decideMemoryTimer();
          reject(false);
        }
      )
    })
   

  }

  async addToAlbum(response) { //common
    this.universalService.showLoader = false;
    this.universalService.objectSelected = false;
    //Add newly created album to DB from addToAlbum flow
    var result = await this.db.getAllData(this.albumsImpl.myAlbumStoreName,"album");
    if(result && result != false) {
      if(response.board) this.db.add(this.myAlbumsDBStoreName,response.board);
    }
    if(response["processed"] == undefined && response["objects"] == undefined){
      if(response["unprocessed"][0].errorCode == "BRSOM0062"){
        this.universalService.showToast(TOAST["FILE_EXISTS_ON_ALBUM"], "error")  
      } else {
        this.universalService.showToast(response["unprocessed"][0].errorMessage, "error")  
      }
    }else if (response["processed"] == this.universalService.objectsToBeAdded.length  || response["objects"].length == this.universalService.objectsToBeAdded.length) {
      this.universalService.showToast(TOAST["ADD_TO_ALBUM_SUCCESS"], "success")
      this.universalService.viewButtonUrl = '/albums/myalbums/'+ this.universalService.selectedFile["boardKey"]
      this.universalService.showViewButton = true;
    } else {
      if(response["objects"]){
        response["processed"] = response["objects"].length;
      }
      this.universalService.showToast(response["processed"] + ' out of ' + this.universalService.objectsToBeAdded.length + ' item(s) added to selected album successfully', "success")
    }
    setTimeout(() => {
      this.universalService.disableModalBackdrop();
      this.listService.deSelectAll(null);
    }, 500)
  }



  createFolder(folderName, url) { //common
    this.loggerService.log("folderName is",folderName,url)
    let parentObjectKey=0
    if(this.universalService.popUpToBeOpened == "movePopUp"){
      parentObjectKey=this.universalService.selectedNodes[0].parentObjectKey ? this.universalService.selectedNodes[0].parentObjectKey : this.universalService.selectedNodes[0]["FullObject"].parentObjectKey;
    }

    var params = {
      "objectName": folderName,
      "parentObjectKey": this.listService.parentFolderKey,
      "sourceName": "DRIVE"
    }
    var self = this;
    return new Promise(async function (resolve, reject) {
      self.http.post(url, params).subscribe(
        suc => {
          self.listService.createFolderObject = false;
          self.universalService.emptyFolder = false;
          // self.universalService.emptyTab = false;
          self.universalService.objectSelected = true;
          self.universalService.selectedFolder = suc;
          self.universalService.createFolderApiResponse  = suc;
          
          if( self.universalService.popUpToBeOpened == "movePopUp" && (self.universalService.currentTab == 'allfiles' || self.universalService.currentTab == "PrivateFolder") 
              &&  parentObjectKey == self.listService.parentFolderKey){
            self.universalService.onMoveFolderCreationSameFolder = true
          }
          if(self.universalService.selectedFolder != undefined && self.universalService.currentTab == "PrivateFolder"){
            self.cleverTapEventsService.pfNewFolderCreated();
          }else{
            self.cleverTapEventsService.cretaeFolder(folderName);
          }
          resolve("folder created")
          
        },
        err => {
          self.loggerService.log("error from create folder api is",err)
          if (err["error"]["error"] == 'Object name already exists.') {
            self.universalService.errorMessage = HTML_ERRORS["FOLDERNAME_EXISTS"];
            self.universalService.showLoader = false;
          } else {
            self.universalService.showErrorMessage(err);
            self.universalService.isServerError = false;
          }
          reject(err);
        }
      )
    });
  }

  createNestedSharedFolder(folderName, url) { //common
    this.loggerService.log("folderName is",folderName,url)
    
    var params = {
      "objectName": folderName
    }
    var self = this;
    return new Promise(async function (resolve, reject) {
      self.http.post(url, params).subscribe(
        suc => {
          self.listService.createFolderObject = false;
          self.universalService.emptyFolder = false;
          self.universalService.emptyTab = false;
          self.universalService.objectSelected = true;
          self.universalService.selectedFolder = suc;
          self.universalService.createFolderApiResponse  = suc;
          self.cleverTapEventsService.cretaeFolder(folderName)
          resolve("folder created")
          
        },
        err => {
          self.loggerService.log("error from create folder api is",err)
          if (err["error"]["error"] == 'Object name already exists.') {
            self.universalService.errorMessage = HTML_ERRORS["FOLDERNAME_EXISTS"];
            self.universalService.showLoader = false;
          } else {
            self.universalService.showErrorMessage(err);
            self.universalService.isServerError = false;
          }
          reject(err);
        }
      )
    });
  }

  createNestedTeamFolder(payload, url) { //TF
    this.loggerService.log("folderName is",payload,url);
    var self = this;
    return new Promise(async function (resolve, reject) {
      self.http.post(url, payload).subscribe(
        suc => {
          var userData = self.localStorageService.getUserData(true);
          suc["objectCreatedBy"] = {
            "userId" : userData["userId"],
            "firstName" : userData["firstName"] ? userData["firstName"] : "-",
            "lastName" : userData["lastName"] ? userData["lastName"] : "-"
          }
          self.listService.createFolderObject = false;
          self.universalService.emptyFolder = false;
          self.universalService.emptyTab = false;
          self.universalService.objectSelected = true;
          self.universalService.selectedFolder = suc;
          self.universalService.createFolderApiResponse  = suc;
          
          resolve("folder created");
        },
        err => {
          self.loggerService.log("error from create folder api is",err)
          if (err["error"]["error"] == 'Object name already exists.') {
            self.universalService.errorMessage = HTML_ERRORS["FOLDERNAME_EXISTS"];
            self.universalService.showLoader = false;
          } else {
            self.universalService.showErrorMessage(err);
            self.universalService.isServerError = false;
          }
          reject(err);
        }
      )
    });
  }

  createAlbum(albumName) { //common
    var params = {
      "boardName": albumName,
      "boardDescription": "",
      "parentObjectKey": null
    }
    const url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG["commonUrls"]["albumDetails"];
    var self = this;
    return new Promise(async function (resolve, reject) {
      self.http.post(url, params).subscribe(
        suc => {
          self.universalService.createAlbumObject = false;
          self.universalService.selectedFile = suc
          self.enableButton = false;
          self.cleverTapEventsService.createAlbum(albumName,self.universalService.currentTab)
          resolve(suc)
        },
        err => {
          reject(err);
          if (err["error"]["error"] == 'Object name already exists.') {
            self.universalService.errorMessage = err["error"]["error"]
          } else {
            self.universalService.showErrorMessage(err);
            self.universalService.isServerError = false;
          }
        }
      )
    });
  }



  fetchNestedFoldersData(event) { //common
    if (this.universalService.popUpToBeOpened == "movePopUp"){
      var found;
      if(this.universalService.selectedFolder) {
        found =this.universalService.selectedNodes.find(obj=> {
          const parentObjectKey = obj["parentObjectKey"] ? obj["parentObjectKey"] : obj["FullObject"]["parentObjectKey"];
          return parentObjectKey == this.universalService.selectedFolder["objectKey"];
        })
      }
      this.universalService.objectSelected = found ? false : true;
    }
   
    
    this.universalService.showLoader = true;
    this.doubleClicked = true;
    this.listService.parentFolderKey = event.data["FullObject"]["objectKey"];
    const currentObjectKey = event.data["FullObject"]["objectKey"];
    const folderAlreadyPresent = this.folderKeys.find((key)=>{
      return key == currentObjectKey;
    })   
    if(!folderAlreadyPresent){
      this.folderKeys.push(event.data["FullObject"]["objectKey"]);
      this.folderNames.push(event.data["FullObject"]);
      this.folderService.breadCrumbsListMoveCopy.push({
        "objectKey": event.data["FullObject"]["objectKey"],
        "objectName": event.data["FullObject"]["objectName"],
        "folder":event.data["FullObject"]
      })
    }
  }

  goBackToPreviousScreen(){ //common
    this.universalService.disableModalBackdrop();
    this.universalService.errorMessage = ""
    if (this.universalService.popUpToBeOpened == "addToJioCloud" || this.universalService.popUpToBeOpened == "movePopUp" || this.universalService.popUpToBeOpened == "copyPopUp" || this.universalService.popUpToBeOpened == "create Folder" ) {
      this.listService.createFolderObject = false;
    } else {
      this.listService.createAlbumObject = false;
    }
    if(this.universalService.popUpToBeOpened != "create Folder"){ // if create folder is open, we should not show backdrop on closing
    this.universalService.disableModalBackdrop();
    this.universalService.showModalBackdrop();
    }
  }

  resetValuesBeforeCreatingFolder() { //common
    this.listService.createFolderObject = true;
    this.enableButton = false;
    this.universalService.disableModalBackdrop();
    this.universalService.showModalBackdrop();
    setTimeout(()=>{
     // (<HTMLInputElement>document.getElementById("folderName")).focus();
    },1000)
  }
  resetValuesBeforeCreatingAlbum() { //common
    this.listService.createAlbumObject = true;
    this.enableButton = false;
    setTimeout(() => {
      (<HTMLInputElement>document.getElementById("AlbumName")).focus();
    }, 500);
    this.universalService.disableModalBackdrop();
    this.universalService.showModalBackdrop();
  }



  closeCreateModal() { //common
    this.universalService.errorMessage = ""
    if(this.universalService.isMobileDevice){
      this.goBackToPreviousScreen()
    }else{
      this.listService.deSelectAll(null);
    }
    
  }


  removeFolderKeys() { //common
    this.universalService.showLoader = true;
    this.folderKeys.pop();
    this.listService.parentFolderKey = this.folderKeys[this.folderKeys.length - 1];
    this.doubleClicked = false
  }


  fetchNestedFoldersDataForMobile(event){ //common
    var focusedCell;
    if(this.universalService.popUpToBeOpened == "movePopUp" || this.universalService.popUpToBeOpened == "copyPopUp"){
      focusedCell = this.listService.moveCopyOptions.api.getFocusedCell();
    }else{
      focusedCell = this.listService.addToJCOptions.api.getFocusedCell();
    }
    if(this.universalService.popUpToBeOpened == "addToJioCloud"){
      this.doubleClicked = true;
      this.listService.parentFolderKey = event.data["FullObject"]["objectKey"];
      const currentObjectKey = event.data["FullObject"]["objectKey"];
      const folderAlreadyPresent = this.folderKeys.find((key)=>{
        return key == currentObjectKey;
      })   
      if(!folderAlreadyPresent){
        this.folderKeys.push(event.data["FullObject"]["objectKey"]);
        this.folderNames.push(event.data["FullObject"]);
      }




    }else
    if(focusedCell["column"]["colId"]=="ImagePath"){
      this.fetchNestedFoldersData(event);
    }else{
      return;
    }




  }


  

  validateBeforeCreatingFolder(foldName:string){ //common
    var regex =  /[/\/\\/<>:"|?*]/;
    this.folderName = foldName
    if(this.folderName == "" || this.folderName.trim().length == 0){
      this.enableButton = false;
      this.universalService.errorMessage = HTML_ERRORS["FOLDERNAME"];
    }else if(this.folderName.match(regex)){
      this.enableButton = false;
      this.universalService.errorMessage = HTML_ERRORS["FOLDERNAME_INVALID_CHAR"];
    }else if(this.folderName.charAt(this.folderName.length-1) == '.'){
      this.enableButton = false;
      this.universalService.errorMessage = HTML_ERRORS["FOLDERNAME_INVALID_END"];
    }else if(!(this.folderName.match(regex))){
      this.enableButton  = true;
      this.universalService.errorMessage = ""
    }
    this.loggerService.log("folder name is",this.folderName,this.enableButton)
  }
  validateBeforeCreatingAlbum(brdName){ //common
    this.albumName = brdName.value
    if(this.albumName == "" || this.albumName.trim().length == 0){
      this.enableButton = false;
    }else{
      this.enableButton = true;
    }
    let brdNameEl = (document.getElementById(brdName.id)) as any;
    if(brdNameEl.value.length >= 50){
      brdNameEl.value = brdNameEl.value.substr(0, 50);
    }
  }


  close(){ //common
    this.folderKeys = [USER_DETAILS["USER_DETAILS"]["rootFolderKey"]] // this is added to reset the folder keys to root folder object key when move/copy modal is closed, it will not impact any other modals as this array is being used only on move and copy.
    if(this.folderService?.breadCrumbsListMoveCopy.length > 1){
      this.folderService.breadCrumbsListMoveCopy = [{objectKey: '1', objectName: 'All Files', folder: null}];
    }
    this.listService.deSelectAll();
  }


  MoveObjects(url,payload){
    var self = this;
    var parentObjectKey = payload[0]["object"]["parentObjectKey"];
    var params = {
      objects:payload
    }
    this.localStorageService.setFolderDataInWhichUploadIsInitiated(JSON.stringify(this.universalService.selectedFolder));
    return new Promise(async function (resolve, reject) {
      self.http.put(url,params).subscribe(
        moveResponse =>{
          var object = {
            "redirectUser": true,
            "selectObjects": false,
            "redirectFolderKey": parentObjectKey,
            "locationOfUpload": self.universalService.currentTab,
            "uploadedFolderKey": parentObjectKey  ? parentObjectKey : USER_DETAILS["USER_DETAILS"]["rootFolderKey"]
          }
          self.ignoreIcloudFolderForFileOperations(moveResponse["unprocessed"]);
          AppEvents.toastMessageEvent.next({"action":"view","data":object})
          self.loggerService.log("moved successfully",moveResponse);
          //Remove from DB if at root level
          //self.refreshIndexDB(moveResponse,"Move","",false);
          if(!self.router.url.includes("privatefolder"))
            self.addToDBForMoveCopy(moveResponse, "MOVE");
          if(moveResponse["unprocessed"] && moveResponse["unprocessed"].length > 0 && moveResponse["unprocessed"][0]["object"]["errorCode"] == "NMSOM0106"){
            resolve({'msg':'moved successfully','containsIcloudFolder':true})
          }else{
            resolve({'msg':'moved successfully','containsIcloudFolder':false})
          }
          // resolve("moved successfully")
        },
        err=>{
          self.loggerService.log(" error in moving the selected files",err);
          reject(err);
        }
      )
    })
  }
  
  deleteObjects(url,payload,files){
    var self = this;
    var params = {
      objects:payload
    }

    let isShareOperation:any = false
    if(url.indexOf(ENV_CONFIG.commonUrls["collabShare"]) > 0){
      isShareOperation = true
    }
    return new Promise(async function (resolve, reject) {
    self.http.put(url,params).subscribe(
      deleteResponse =>{
        // if(self.universalService.showPreview){
        //   self.previewImplementation.deleteORMoveObject('delete');
        // }
          self.cleverTapEventsService.onShareDeleteClick(self.universalService.currentTab); 
          self.loggerService.log("deleted successfully",deleteResponse);
          //update used space post delete
          if(deleteResponse?.usedSpace >=0) {
            let userData = self.localStorageService.getUserData(true);
            deleteResponse["usedSpace"] = deleteResponse["usedSpace"] == 0 ? 0 : (deleteResponse["usedSpace"] ? deleteResponse["usedSpace"] : userData["quota"]["totalUsedQuota"]);
            userData["quota"]["totalUsedQuota"] = deleteResponse["usedSpace"];
            AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,updateStorageRepresentationOnUI:true});
          }
          self.refreshIndexDB(deleteResponse,"TRASH",files,isShareOperation);
          AppEvents.memorySubscriptions.next({reinvokememory:true});
          self.checkStorageAfterDeletingFiles(deleteResponse);
          self.ignoreIcloudFolderForFileOperations( deleteResponse["unprocessed"]);


          if(deleteResponse["unprocessed"] && deleteResponse["unprocessed"].length > 0 && deleteResponse["unprocessed"][0]["object"]["errorCode"] == "NMSOM0106"){
            resolve({'msg':'deleted successfully','containsIcloudFolder':true})
          }else{
            resolve({'msg':'deleted successfully','containsIcloudFolder':false})
          }
        
      },
      err=>{
        self.loggerService.log(" error in deleting the selected file",err);
        self.universalService.showLoader = false;
        if (err["error"].unprocessed[0]["errorCode"] == "NMSCL0024") {
          self.universalService.showToast(TOAST["FILE_DOES_NOT_EXIST"], "error");   
        } else if (err["error"].unprocessed[0]["errorCode"] == "NMSCL0021") {
          self.universalService.showToast(err["error"].unprocessed[0]["errorMessage"], "error");
        } else{
          self.universalService.showErrorMessage(err);
        }
        reject(err);
      }
    )
  })
  }

  ignoreIcloudFolderForFileOperations(unproccessedList){
    // let icloudObjectsList = deleteResponse["unprocessed"];
    if(!unproccessedList) return; // when the operation is successful, in some cases we are not getting unprocessed property in the response.
    let self = this;
    unproccessedList.map(icloudObj=>{
      if(self.universalService.listView){
        let selectedRows = self.listService.listOptions.api.getSelectedNodes();
        let findIcloudobjectRow = selectedRows.find(obj=>obj["data"]["objectId"] == icloudObj["object"]["objectKey"]);
        let rowIndexOfIcloudObj = self.listService.listOptions.api.getDisplayedRowAtIndex(findIcloudobjectRow.rowIndex);
        rowIndexOfIcloudObj.setSelected(false);
        self.universalService.selectedNodes = self.listService.listOptions.api.getSelectedRows();

        self.listImpl.indexsArray = Array.from(new Set(self.listImpl.indexsArray));
        let ixInArray =  self.listImpl.indexsArray.indexOf(rowIndexOfIcloudObj["rowIndex"]);
        self.listImpl.indexsArray.splice(ixInArray,1)//[1,2,3,4,5,6]
      }else{
        let selectedRows = self.universalService.selectedNodes;
        let findIcloudobjectRow = selectedRows.find(obj=>obj["objectKey"] == icloudObj["object"]["objectKey"]);
        let rowIndexOfIcloudObj = selectedRows.indexOf(findIcloudobjectRow);
        if(rowIndexOfIcloudObj>=0){
          selectedRows.splice(rowIndexOfIcloudObj,1);
        }
      }
    })
  }
  deleteTFObjects(url,payload,files){
    var self = this;
    
    return new Promise(async function (resolve, reject) {
    self.http.put(url,payload).subscribe(
      deleteResponse =>{
        resolve("deleted successfully")
      },
      err=>{
        self.loggerService.log(" error in deleting the selected file",err);
        self.universalService.showLoader = false;
        if (err["error"].unprocessed[0]["errorCode"] == "NMSCL0024") {
          self.universalService.showToast(TOAST["FILE_DOES_NOT_EXIST"], "error");   
        } else if (err["error"].unprocessed[0]["errorCode"] == "NMSCL0021") {
          self.universalService.showToast(err["error"].unprocessed[0]["errorMessage"], "error");
        } else{
          setTimeout(() => { // this timeout has been added to show toast message if any present in below function, without the timeout, the place where the promise of deleteTFObjects is getting rejected is showing a generic toast message instead of the one from the below function.
            self.universalService.showErrorMessage(err);
          }, 10);
        }
        reject(err);
      })
    })
  }

  async addToDBForMoveCopy(response, operation) {

    var destinationObjectKey;
    var isRootSelected = false;
    var isClearFilter = false;
    var filesArr = [];
    
    var photoArr = [];
    var videoArr = [];
    var audioArr = [];
    var docsArr = [];
    var foldersArr =[];
    var self = this;
    if(this.universalService.selectedFolder == undefined){
        destinationObjectKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
        isRootSelected = true;
    }else if( this.universalService.currentTab !="PrivateFolder" &&  this.universalService.selectedFolder != undefined && this.universalService.selectedFolder.parentObjectKey == USER_DETAILS["USER_DETAILS"]["rootFolderKey"]){
      destinationObjectKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
      isRootSelected = true;
    }else if( this.universalService.currentTab !="PrivateFolder" &&  this.universalService.selectedFolder != undefined && this.universalService.selectedFolder.objectName == "Private Folder"){
      isRootSelected = true;
      isClearFilter = true;
    }else{
        destinationObjectKey = this.universalService.selectedFolder["objectKey"];
        isRootSelected = (destinationObjectKey == USER_DETAILS["USER_DETAILS"]["rootFolderKey"])?true:false;
    }
    this.db.clearStore("RecentFilesMetadata");
    if((isRootSelected || this.universalService.cutCopiedFilesWithKeyboard.length > 0) && operation == 'MOVE'){
        this.cacheImpl.clearStores("FOLDERS");
        this.cacheImpl.clearStores("ALL_FILES");
        if(isClearFilter){
          this.cacheImpl.clearStores("FILTERS");
        }
    }else if(operation == 'COPY'){
        if(isRootSelected){
          this.cacheImpl.clearStores("FOLDERS");
          this.cacheImpl.clearStores("ALL_FILES");
        }
        this.cacheImpl.clearStores("FILTERS");
    }else if(operation == 'MOVETOPF'){
      if(isRootSelected){
        this.cacheImpl.clearStores("FOLDERS");
        this.cacheImpl.clearStores("ALBUMS");
      }
      this.cacheImpl.clearStores("ALL_FILES");
      this.cacheImpl.clearStores("FILTERS");
    }else if(operation == 'MOVEOUTOPF'){
      this.cacheImpl.clearStores("ALL_FILES");
      this.cacheImpl.clearStores("FILTERS");
    }
    if(operation != 'COPY')
      this.universalService.cutCopiedFilesWithKeyboard = [];
  }
  
  saveToIndexDB(operationName, storeArray, data) {
    var self = this;

    if(data != undefined) {
      if(operationName == 'RENAME') {
        storeArray.forEach((storeName) => {
          self.db.getByIndex(storeName, 'objectKey', data.objectKey).then(function(object: any) {
            data.id = object.id;
            object.objectName = data.objectName;
            object.lastModifiedDate = data.lastModifiedDate;
            self.db.update(storeName, object);
          }, function(error) {
              console.log("objectKey is not present",error);
          });
        });
      } else if(operationName == 'TRASH' || operationName == 'MOVE') {
        storeArray.forEach((storeName) => {
          self.db.getByIndex(storeName, 'objectKey', data.objectKey).then(function(object: any) {
            self.db.deleteByKey(storeName, object.id);
          }, function(error) {
            console.log("objectKey is not present",error);
          });
        });
      } else if(operationName == 'SETFAV' || operationName == 'UNSETFAV') {
        storeArray.forEach((storeName) => {
          self.db.getByIndex(storeName, 'objectKey', data.objectKey).then(function(object: any) {
            data.id = object.id;
            object.isFavorite = data.isFavorite;
            object.lastModifiedDate = data.lastModifiedDate;
            self.db.update(storeName, object);
          }, function(error) {
            console.log("objectKey is not present",error);
          });
        });
      } else if(operationName == 'ManageShare') {
        storeArray.push('RecentFilesMetadata');
        storeArray.forEach((storeName) => {
          self.db.getByIndex(storeName, 'objectKey', data.objectKey).then(function(object: any) {
            data.id = object.id;
            object.shareKey = data.shareKey;
            object.shareLink = data.shareLink;
            object.isShared = data.isShared;
            object.shareType = data.shareType;
            self.db.update(storeName, object);
          }, function(error) {
            console.log("objectKey is not present",error);
          });
        });
      } else if(operationName == 'FTR') {
        //removing coverpic
        storeArray.forEach((storeName) => {
          self.db.getByIndex(storeName, 'boardKey', data.boardKey).then(function(object: any) {
            object.filesCount = object.filesCount - 1;
            if(self.universalService.currentAlbum.boardCoverPicObjectKey == data.objectKey) {
              object.boardCoverPic = '';
              object.boardCoverPicObjectKey = '';
              if(object.filesCount == 0) {
                self.db.update(storeName, object);
              } else {
                self.db.clearStore(storeName);
              }
            } else {
              self.db.clearStore(storeName);
            }
          }, function(error) {
            console.log("objectKey is not present",error);
          });
        });
      }
    } else {
      console.log("data is empty");
    }
  }

  updateToIndexDB(storeArray, data) {
    var self = this;
      storeArray.forEach((storeName) => {
       // self.db.getByIndex(storeName, 'parentObjectKey', data.parentObjectKey).then(function(object: any) {
         // self.db.deleteByKey(storeName, object.id);
         self.db.clearStore(storeName);
       // }, function(error) {
        //});
      });
    
  } 
  getIndexDBStoresTobeUpdate (object,isRequireAllStore) {
     var objectType = object.objectType;
     var displayName = (objectType == "FE" && object.displayName)?object.displayName.toLowerCase():"";

    var storesName = []
    
    if(isRequireAllStore){
      storesName.push('VideosMetadata_ObjectName');
      storesName.push('VideosMetadata_FileCreatedDate');
      storesName.push('VideosMetadata_CreatedDate');
      storesName.push('VideosMetadata_ObjectName_Desc');
      storesName.push('VideosMetadata_FileCreatedDate_Asc');
      storesName.push('VideosMetadata_CreatedDate_Asc');
      storesName.push('PhotosMetadata_ObjectName');
      storesName.push('PhotosMetadata_FileCreatedDate');
      storesName.push('PhotosMetadata_CreatedDate');
      storesName.push('PhotosMetadata_ObjectName_Desc');
      storesName.push('PhotosMetadata_FileCreatedDate_Asc');
      storesName.push('PhotosMetadata_CreatedDate_Asc');
      storesName.push('AudiosMetadata_Name_Asc');
      storesName.push('AudiosMetadata_Name_Desc');
      storesName.push('AudiosMetadata_FileCreatedDate_Asc');
      storesName.push('AudiosMetadata_FileCreatedDate_Desc');
      storesName.push('AudiosMetadata_CreatedDate_Asc');
      storesName.push('AudiosMetadata_CreatedDate_Desc');
      storesName.push('DocumentMetadata_Name_Asc');
      storesName.push('DocumentMetadata_Name_Desc');
      storesName.push('DocumentMetadata_Size_Asc');
      storesName.push('DocumentMetadata_Size_Desc');
      storesName.push('DocumentMetadata_Type_Asc');
      storesName.push('DocumentMetadata_Type_Desc');
      storesName.push('DocumentMetadata_Type_Asc');
      storesName.push('DocumentMetadata_Type_Desc');
      storesName.push('DocumentMetadata_FileCreatedDate_Asc');
      storesName.push('DocumentMetadata_FileCreatedDate_Desc');
      storesName.push('DocumentMetadata_CreatedDate_Asc');
      storesName.push('DocumentMetadata_CreatedDate_Desc');
    }else{
    
      if(objectType == 'FR') {
        storesName.push("AllFiles_FolderMetadata_Name_Asc");
        storesName.push("AllFiles_FolderMetadata_Date_Desc");
        storesName.push("AllFiles_FolderMetadata_Name_Desc");
        storesName.push("AllFiles_FolderMetadata_Date_Asc");
    //  storesName.push("AllFiles_FolderMetadata_Date_Asc");//"AllFiles_FolderMetadata_UploadDate_Asc"
    //  storesName.push("AllFiles_FolderMetadata_Date_Desc");//"AllFiles_FolderMetadata_UploadDate_Desc";
  
      }else{
        storesName.push("AllFilesMetadata_Grid_Name_Asc");
        storesName.push("AllFilesMetadata_Grid_Date_Desc");
        storesName.push("AllFilesMetadata_Grid_Name_Desc");
        storesName.push("AllFilesMetadata_Grid_Date_Asc");
        storesName.push("AllFilesMetadata_Grid_CreatedDate_Asc");
        storesName.push("AllFilesMetadata_Grid_CreatedDate_Desc");
  
        if(displayName == 'video') {
          storesName.push('VideosMetadata_ObjectName');
          storesName.push('VideosMetadata_FileCreatedDate');
          storesName.push('VideosMetadata_CreatedDate');
          storesName.push('VideosMetadata_ObjectName_Desc');
          storesName.push('VideosMetadata_FileCreatedDate_Asc');
          storesName.push('VideosMetadata_CreatedDate_Asc');
        } else if(displayName == 'image') {
          storesName.push('PhotosMetadata_ObjectName');
          storesName.push('PhotosMetadata_FileCreatedDate');
          storesName.push('PhotosMetadata_CreatedDate');
          storesName.push('PhotosMetadata_ObjectName_Desc');
          storesName.push('PhotosMetadata_FileCreatedDate_Asc');
          storesName.push('PhotosMetadata_CreatedDate_Asc');

        } else if(displayName == 'audio') {
          storesName.push('AudiosMetadata_Name_Asc');
          storesName.push('AudiosMetadata_Name_Desc');
          storesName.push('AudiosMetadata_FileCreatedDate_Asc');
          storesName.push('AudiosMetadata_FileCreatedDate_Desc');
          storesName.push('AudiosMetadata_CreatedDate_Asc');
          storesName.push('AudiosMetadata_CreatedDate_Desc');
        } else if(objectType != 'FR')  {
          storesName.push('DocumentMetadata_Name_Asc');
          storesName.push('DocumentMetadata_Name_Desc');
          storesName.push('DocumentMetadata_Size_Asc');
          storesName.push('DocumentMetadata_Size_Desc');
          storesName.push('DocumentMetadata_Type_Asc');
          storesName.push('DocumentMetadata_Type_Desc');
          storesName.push('DocumentMetadata_Type_Asc');
          storesName.push('DocumentMetadata_Type_Desc');
          storesName.push('DocumentMetadata_FileCreatedDate_Asc');
          storesName.push('DocumentMetadata_FileCreatedDate_Desc');
          storesName.push('DocumentMetadata_CreatedDate_Asc');
          storesName.push('DocumentMetadata_CreatedDate_Desc');
        }
      }
    }
    return storesName;
  }

 

  refreshIndexDB(response,operation,inputFiles,isShareOperation) {
    var self = this;
    if(isShareOperation && ( operation == "RENAME" )){//operation == "TRASH" ||
      if(inputFiles != undefined) {
        if(self.universalService.isMobileDevice){
          
          inputFiles.forEach((object) => {
            if( operation == 'TRASH' && object.objectType == 'FR'){
              self.updateToIndexDB(self.getIndexDBStoresTobeUpdate(object,true), object);
            }
            self.saveToIndexDB(operation, self.getIndexDBStoresTobeUpdate(object,false), object);
          });
        }else{
          inputFiles.forEach((object) => {
            if( operation == 'TRASH' && object.FullObject.objectType == 'FR'){
              self.updateToIndexDB(self.getIndexDBStoresTobeUpdate(object.FullObject,true), object.FullObject);
            }
            if( operation == 'RENAME' ){
              self.saveToIndexDB(operation, self.getIndexDBStoresTobeUpdate(object,false), object);
            }else{
              self.saveToIndexDB(operation, self.getIndexDBStoresTobeUpdate(object.FullObject,false), object.FullObject);
            }
            
          });
        }
        
      }
    }else{
      if(operation == "TRASH"){
        this.cacheImpl.clearMyFilesStores()
      
      }else if(response.objects != undefined && typeof response.objects == 'object') {
        response.objects.forEach((object) => {
          if( object.operation == 'TRASH' && object.object.objectType == 'FR'){
           // self.updateToIndexDB(self.getIndexDBStoresTobeUpdate(object.object,true), object.object);
          }

          if(object.operation == 'FTR') {
            self.saveToIndexDB(object.operation, ['MyAlbumsList'], object.object);
          } else  if( object.operation != 'TRASH' ) {
            self.saveToIndexDB(object.operation, self.getIndexDBStoresTobeUpdate(object.object,false), object.object);
          }
        });
      }

     /* //unprocessed object
      if(response.unprocessed != undefined && typeof response.unprocessed == 'object' && operation == 'TRASH') {
        response.unprocessed.forEach((object) => {
          let inputInfo = undefined
          inputFiles.forEach((inputObject)=>{
            if(inputObject.objectKey == object.object.objectKey){
              inputInfo = inputObject;
            }
              
          })
          if(inputInfo!=undefined && object.operation == 'TRASH' && object.object.errorCode == 'NMSOM0063'){
            self.saveToIndexDB(object.operation, self.getIndexDBStoresTobeUpdate(inputInfo,false), inputInfo);
          }
        });
      }
      */
    }


   
    //this.db.deleteByKey("RecentFilesMetadata",storeName); //This to be uncommented during improvement 
    this.db.clearStore("RecentFilesMetadata");
  }

  renameObject(url,payload,files){
    var self = this;
    var params : any;
    self.universalService.updatedObject =  undefined;
    let isShareOperation:any = false
    if(url.indexOf(ENV_CONFIG.commonUrls["collabShare"]) > 0){
      params = payload
      isShareOperation = true
    }
    else{
      params = {
        objects:payload
      }
    }
    return new Promise(async function (resolve, reject) {
    self.http.put(url,params).subscribe(
      renameResponse =>{ 
        if(renameResponse != null && renameResponse["unprocessed"] && renameResponse["unprocessed"].length != 0){// if any files are under the unprocessed array
          self.universalService.showLoader = false;
          if(renameResponse.unprocessed[0].object.errorCode == "NMSOM0064"){
            if(self.universalService.selectedFile.objectType == 'FE'){
              self.universalService.showToast(TOAST["FILENAME_EXISTS"], "error");
            }
            else{
              self.universalService.showToast(TOAST["FOLDERNAME_EXISTS"], "error");
            }
          }else if(renameResponse.unprocessed[0].object.errorCode == "NMSOM0106"){
            jQuery("[class*='modal-backdrop']").remove();
            AppEvents.optionSelected.next({closeAll:true});
            self.listService.deSelectAll();
            self.universalService.showToast(TOAST["SYSTEM_FOLDER_RESTRICTED_OPERATIONS"] +  "renamed", 'error')
          }
          else self.universalService.showToast(renameResponse.unprocessed[0].object.errorMessage, "error");
          self.universalService.selectedFile["objectName"] = self.universalService.selectedFileOldName;
        } else {
          self.universalService.updatedObject =  renameResponse; 
          self.loggerService.log("renamed successfully",renameResponse);
          self.refreshIndexDB(renameResponse,"RENAME",[files],isShareOperation);
          /*self.saveToIndexDB(renameResponse.objects[0].operation, self.getIndexDBStoresTobeUpdate(renameResponse.objects[0].object), renameResponse.objects[0].object);
          //self.db.deleteByKey("RecentFilesMetadata",storeName); //This to be uncommented during improvement
          self.db.clearStore("RecentFilesMetadata");*/
  
          // delete self.universalService.selectedFile["oldNameBeforeRenaming"];
          resolve("renamed successfully")
        }
      },
      err=>{
        self.universalService.selectedFile["objectName"] = self.universalService.selectedFileOldName;
        // delete self.universalService.selectedFile["oldNameBeforeRenaming"];
        self.loggerService.log(" error in renameing the selected file",err);
        self.universalService.selectedFile["objectName"] = self.universalService.selectedFileOldName;
        reject(err);
      }
    )
  })
  }

  renameTFObject(url,payload,files){
    var self = this;
    self.universalService.updatedObject =  undefined;
    payload = Array.isArray(payload)?payload[0]:payload;
    return new Promise(async function (resolve, reject) {
    self.http.put(url,payload).subscribe(
      renameResponse =>{ 
        if(renameResponse != null && renameResponse["unprocessed"] && renameResponse["unprocessed"].length != 0){// if any files are under the unprocessed array
          self.universalService.showLoader = false;
          self.universalService.showToast(renameResponse.unprocessed[0].object.errorMessage, "error");
          self.universalService.selectedFile["objectName"] = self.universalService.selectedFileOldName;
        } else {
          self.universalService.updatedObject =  renameResponse; 
          self.loggerService.log("renamed successfully",renameResponse);
          resolve("renamed successfully")
        }
      },
      err=>{
        self.universalService.selectedFile["objectName"] = self.universalService.selectedFileOldName;
        // delete self.universalService.selectedFile["oldNameBeforeRenaming"];
        self.loggerService.log(" error in renameing the selected file",err);
        self.universalService.selectedFile["objectName"] = self.universalService.selectedFileOldName;
        setTimeout(() => { // this timeout has been added to show toast message if any present in below function, without the timeout, the place where the promise of renameTFObject is getting rejected is showing a generic toast message instead of the one from the below function.
          self.universalService.showErrorMessage(err);
        }, 10);
        reject(err);
      }
    )
  })
  }

  getUserContactsEmails(url) {
    
    var self = this;
    return new Promise((resolve, reject) => {
      self.http.get(url)
      .subscribe(
         response =>{
          resolve(response);
        },
        error =>{
         console.log("error", error);
         self.universalService.showLoader = false;
         reject(error)
      })

    }) 
  }

  setAccessedDate(url,file){
    if(!this.universalService.userLoggedIn)
      return;
    var self = this;
    // var obj;
    // var params = {
    //   objects: []
    // };
    // if(this.universalService.selectedNodes[0].FullObject){
    //   obj = this.universalService.selectedNodes[0].FullObject;
    // }else{
    //   obj = this.universalService.selectedNodes[0];
    // }
    // params.objects.push({
    //   "operation":"SETACCESSEDDATE",
    //   "correlationId": USER_DETAILS["USER_DETAILS"]["userId"],
    //   "object":file
    // });
    return new Promise(async function (resolve, reject) {
      self.http.put(url).subscribe(
        response =>{
          self.universalService.showLoader = false;
          resolve(response);
        },
        error =>{
          console.log("error", error);
          reject(error)
      })
    })
  }

  renameAlbumObject(url,payload){
    var self = this;
    var params = {
      operations:payload,
      parentObjectKey:null
    }
    return new Promise(async function (resolve, reject) {
    self.http.post(url,params).subscribe(
      renameResponse =>{
        self.loggerService.log("renamed successfully",renameResponse);
        if(renameResponse["unprocessed"] && renameResponse["unprocessed"][0]["errorCode"]=="BRSOM0110") {//if user was removed from shared album
          self.universalService.showToast(TOAST["USER_NOT_PART_OF_ALBUM"], "error");
          //redirect to main albums
          if(self.universalService.currentAlbum["isShareAlbum"]){
            self.router.navigate(['/albums/sharedalbums'])
            return
          }
          self.router.navigate(['/albums/myalbums']);
        } else if(renameResponse["unprocessed"]){
          self.universalService.showToast(renameResponse["unprocessed"][0]["errorMessage"], "error");
          self.universalService.showLoader = false;
        } else {
          resolve("renamed successfully")
        }
        
      },
      err=>{
        self.loggerService.log(" error in renameing the selected file",err);
        self.universalService.selectedFile["objectName"] = self.universalService.selectedFile["actualObjectName"]
        self.universalService.selectedNodes[0] = self.universalService.selectedFile;
        self.universalService.showLoader = false;
        reject(err);
      }
    )
  })
  }

  deleteAlbumFiles(url,payload){
      var self = this;
      var params = {
        operations:payload,
        parentObjectKey:null
      }
      return new Promise(async function (resolve, reject) {
      self.http.post(url,params).subscribe(
        deleteResponse =>{
          self.loggerService.log("deleted successfully",deleteResponse);

          if(deleteResponse["unprocessed"] && deleteResponse["unprocessed"][0]["errorCode"]=="BRSOM0110") {//if user was removed from shared album
            self.universalService.showToast(TOAST["USER_NOT_PART_OF_ALBUM"], "error");
            //redirect to main albums
            if(self.universalService.currentAlbum["isShareAlbum"]){
              self.router.navigate(['/albums/sharedalbums'])
              return
            }
            self.router.navigate(['/albums/myalbums']);
          } else if(deleteResponse["unprocessed"]){
            self.universalService.showToast(deleteResponse["unprocessed"][0]["errorMessage"], "error");
            self.universalService.showLoader = false;
          } else {
            self.refreshIndexDB(deleteResponse, "FTR", "", null);
            self.checkStorageAfterDeletingFiles(deleteResponse);
            self.checkIfCoverPicIsDeleted(deleteResponse);
            resolve("deleted successfully")
          }
          
        },
        err=>{
          self.loggerService.log(" error in renameing the selected file",err);
          self.universalService.showLoader = false;
          reject(err);
        }
      )
    })
  }

  setObjectAsFavorite(url,payload){
    var self = this;
    var params = {
      objects:payload
    }
    return new Promise(async function (resolve, reject) {
    self.http.put(url,params).subscribe(
      async favoriteResponse =>{
        if(favoriteResponse["unprocessed"] && favoriteResponse["unprocessed"].length != 0){ // if any files are under the unprocessed array, we will set then to previous state and not update them
          var failCount = favoriteResponse["unprocessed"].length;
          var fileText = failCount > 1 ? failCount + " files" : "1 file";
          self.universalService.showToast(fileText + TOAST["SET_FAVORITE_ERROR"], "error");
          await self.unsetFavorite(favoriteResponse["unprocessed"],self.universalService.selectedNodes);
        }
        self.refreshIndexDB(favoriteResponse,"setFav","",false);
        if(!self.router.url.includes('/memory')){
          self.cleverTapEventsService.fileBookmarked(self.universalService.currentTab);
        }
        self.loggerService.log("favorited successfully",favoriteResponse);
        self.universalService.decideMemoryTimer();
        resolve("marked as Favorite")
      },
      err=>{
        self.universalService.decideMemoryTimer();
        self.loggerService.log(" error in marking the selected file as favorite",err);
        reject(err);
      }
    )
  })
  }

  unSetObjectAsFavorite(url,payload){
    var self = this;
    var params = {
      objects:payload
    }
    return new Promise(async function (resolve, reject) {
    self.http.put(url,params).subscribe(
      async unfavoriteResponse =>{
        if(unfavoriteResponse["unprocessed"] && unfavoriteResponse["unprocessed"].length != 0){ // if any files are under the unprocessed array, we will set then to previous state and not update them
          var failCount = unfavoriteResponse["unprocessed"].length;
          var fileText = failCount > 1 ? failCount + " files" : "1 file";
          self.universalService.showToast(fileText + TOAST["UNSET_FAVORITE_ERROR"], "error");
          await self.setFavorite(unfavoriteResponse["unprocessed"],self.universalService.selectedNodes)
        }

        if(self.router.url.includes('/favorites/myfiles')) { // album files we are not catching so only myfiles check
          self.cacheImpl.clearMyFilesStores();
        } else {
          self.refreshIndexDB(unfavoriteResponse,"setUnFav","",false);
        }
        if(!self.router.url.includes('/memory')){
          self.cleverTapEventsService.fileRemoveBookmarked(self.universalService.currentTab)
        }
        self.loggerService.log("unfavorited successfully",unfavoriteResponse);
        self.universalService.decideMemoryTimer();
        resolve("unmarked as Favorite")
      },
      err=>{
        self.universalService.decideMemoryTimer();
        self.loggerService.log(" error in marking the selected file as unfavorite",err);
        reject(err);
      }
    )
  })
  }

  setAlbumFileAsFavorite(url,payload){
    var self = this;
    var params = {
      operations:payload,
      parentObjectKey:null
    }
    return new Promise(async function (resolve, reject) {
      self.http.post(url,params).subscribe(
        async albumfavoriteResponse =>{
          
          self.cleverTapEventsService.fileBookmarked(self.universalService.currentTab)
          self.loggerService.log("favorited successfully",albumfavoriteResponse);
          if(albumfavoriteResponse["unprocessed"] && albumfavoriteResponse["unprocessed"][0]["errorCode"]=="BRSOM0110") {//if user was removed from shared album
            self.universalService.showToast(TOAST["USER_NOT_PART_OF_ALBUM"], "error");
            //redirect to main albums
            if(self.universalService.currentAlbum["isShareAlbum"]){
              self.router.navigate(['/albums/sharedalbums'])
              return
            }
            self.router.navigate(['/albums/myalbums']);

          } else if(albumfavoriteResponse["unprocessed"] && albumfavoriteResponse["objects"]){
            if(albumfavoriteResponse["unprocessed"][0]["errorCode"] == "BRSOM0433") {//If there are objects marked successfully and unprocessed with mentioned code, ignore message as those unfavorited get marked
              self.universalService.showLoader = false;
            } else {
              self.universalService.showToast(albumfavoriteResponse["unprocessed"][0]["errorMessage"], "error");
              self.universalService.showLoader = false;
            }
          } else if(albumfavoriteResponse["unprocessed"]){
            self.universalService.showToast(albumfavoriteResponse["unprocessed"][0]["errorMessage"], "error");
            self.universalService.showLoader = false;
          } else {
            resolve("marked as Favorite")
          }
        },
        err=>{
          self.loggerService.log(" error in marking the album selected file as favorite",err);
          self.universalService.showLoader = false;
          reject(err);
        }
      )
    })
  }

  unSetAlbumFileAsFavorite(url,payload){
    var self = this;
    var params = {
      operations:payload,
      parentObjectKey:null
    }
    return new Promise(async function (resolve, reject) {
      self.http.post(url,params).subscribe(
        async albumunfavoriteResponse =>{
          self.cleverTapEventsService.fileRemoveBookmarked(self.universalService.currentTab)
          self.loggerService.log("unfavorited successfully",albumunfavoriteResponse);
          if(albumunfavoriteResponse["unprocessed"] && albumunfavoriteResponse["unprocessed"][0]["errorCode"]=="BRSOM0110") { //if user was removed from shared album
            self.universalService.showToast(TOAST["USER_NOT_PART_OF_ALBUM"], "error");
            //redirect to main albums
            if(self.universalService.currentAlbum["isShareAlbum"]){
              self.router.navigate(['/albums/sharedalbums'])
              return
            }
            self.router.navigate(['/albums/myalbums']);

          } else if(albumunfavoriteResponse["unprocessed"]){
            self.universalService.showToast(albumunfavoriteResponse["unprocessed"][0]["errorMessage"], "error");
            self.universalService.showLoader = false;
          } else {
            resolve("unmarked as Favorite")
          }
          
        },
        err=>{
          self.loggerService.log(" error in marking the album selected file as unfavorite",err);
          self.universalService.showLoader = false;
          reject(err);
        }
      )
    })
  }

  setFavorite(unprocessedArray,selectedNodes){ // if there are unprocessed objects when unfavoriting a file,the set the unprocessed nodes back to favorite
    
    unprocessedArray.map(obj=>{
      var find = selectedNodes.find(node=> (node["objectKey"] == obj["object"]["objectKey"] || node["objectId"] == obj["object"]["objectKey"]))
      if(find){
        var index = selectedNodes.indexOf(find);
        if(index>=0){
          if(selectedNodes[index]["FullObject"]) {
            selectedNodes[index]["FullObject"]["isFavorite"] = true; 
          } else {
            selectedNodes[index]["isFavorite"] = true; 
          }
        }
      }
    })
  }
  
  unsetFavorite(unprocessedArray,selectedNodes){ // if there are unprocessed objects when favoriting a file,the set the unprocessed nodes back to unfavorite
    unprocessedArray.map(obj=>{
      var find = selectedNodes.find(node=> (node["objectKey"] == obj["object"]["objectKey"] || node["objectId"] == obj["object"]["objectKey"]))
      if(find){
        var index = selectedNodes.indexOf(find);
        if(index>=0){
          selectedNodes.splice(index,1)
          // if(selectedNodes[index]["FullObject"]) {
          //   selectedNodes[index]["FullObject"]["isFavorite"] = false;
          // } else {
          //   selectedNodes[index]["isFavorite"] = false; 
          // }
        }
      }
    })
  }


  updateSummaryCountsAndUI(sortedArray,list,executedTask){ 
    if((this.universalService.currentTab != 'allfiles' && this.universalService.currentTab != 'PrivateFolder')  && executedTask == "MOVE"){
      this.listService.deSelectAll();
      return;
    }
    list.map(object=>{ // for each object in the list
      var indexInPreviewArray,foldersArray;
      foldersArray = this.universalService.foldersArray
      object = object["FullObject"]?object["FullObject"]:object
      if(object["objectType"]=='FR'){
          var find = foldersArray.find(obj=>obj["objectKey"] == object["objectKey"]);
          if(find){
            var index = foldersArray.indexOf(find);  //find the index of object in the folders array
            if(index>=0){
              foldersArray.splice(index,1)
              this.universalService.totalCountOfFolders = foldersArray.length
              if(this.universalService.isMobileDevice && (this.universalService.currentTab == 'allfiles' || this.universalService.currentTab == 'PrivateFolder' || this.universalService.currentTab == 'Trash' || this.universalService.currentTab == 'sharedFiles' || this.universalService.currentTab == "tftrash"  || this.universalService.currentTab == "teamfolders")){
                var find = this.universalService.mobileSelectedObj.find(obj=>obj["objectKey"] == object["objectKey"]);
                var indexInmobileSelectedObj = this.universalService.mobileSelectedObj.indexOf(find);
                if(indexInmobileSelectedObj>=0)
                  this.universalService.mobileSelectedObj.splice(indexInmobileSelectedObj,1);
              }
            }
          }
      }else{
      sortedArray.map((month,monthIndex)=>{ // traverse through each month to find the object
        var indexInSortArray,index;
        var objects = month["objects"];
        
        var find = objects.find(obj=>obj["objectKey"] == object["objectKey"]);
        if(find){
          indexInSortArray = objects.indexOf(find);  //find the index of object in the month
        }


        if(indexInSortArray >=0){
          if(this.universalService.isMobileDevice && this.universalService.showMiniPlayer && this.universalService.currentTab == 'audio'){
            var indexInmobilePlayList = this.universalService.mobilePlayList.indexOf(find);
            //Handle playing song in delete scenario
            if(executedTask =='TRASH') {
              var deletedRowData = this.universalService.mobilePlayList.filter(value => list.includes(value));
              var find = deletedRowData.find(obj=>obj["objectKey"] == this.universalService.selectedAudioFile.objectKey);
              if(find){ // If deleted file is same as one playing.. stop player
                this.universalService.stopAndCloseAudioPlayer();
              }
            }
            if(indexInmobilePlayList>=0)
              this.universalService.mobilePlayList.splice(indexInmobilePlayList,1); // remove that object from that miniplayer
          }
          if( this.universalService.isMobileDevice && ((this.universalService.currentTab == 'allfiles' || this.universalService.currentTab == 'PrivateFolder') && !this.universalService.fetchAllRecentFiles) || this.universalService.currentTab == 'Trash' || this.universalService.currentTab == 'sharedFiles' || this.universalService.currentTab == "tftrash" || this.universalService.currentTab == "teamfolders"){
            var indexInmobileSelectedObj = this.universalService.mobileSelectedObj.indexOf(find);
            if(indexInmobileSelectedObj>=0)
              this.universalService.mobileSelectedObj.splice(indexInmobileSelectedObj,1); // remove that object from that mobileSelectedObj
          }else if( this.universalService.isMobileDevice && this.universalService.currentTab == 'docs' || this.universalService.currentTab == 'audio' || this.universalService.currentTab == 'videos' || this.universalService.currentTab == "photos"){
            var indexInmobileSelectedObj = this.universalService.mobileSelectedObj.indexOf(find);
            if(indexInmobileSelectedObj>=0)
              this.universalService.mobileSelectedObj.splice(indexInmobileSelectedObj,1); // remove that object from that mobileSelectedObj
          }
          objects.splice(indexInSortArray,1); // remove that object from that month
          if(objects.length > 0){
            month["fileCount"] = parseInt(month["fileCount"]) -1 // update the file count beside the month name
          }else if (objects.length == 0){ // if the last object is deleted in that month
            var found = sortedArray.find(m=>m["monthName"] == month["monthName"])
            if(found)
            index = sortedArray.indexOf(found) // delete that month from the summary array
            if(monthIndex >=0){
              sortedArray.splice(monthIndex,1);
            }
          }
        }
       
      })
    }

    if(sortedArray.length == 0) {
      if(this.universalService.currentTab == "tftrash" && this.universalService.foldersArray.length==0){
        this.universalService.emptyFolder = true;
      }
      else if(((this.universalService.currentTab == 'allfiles' || this.universalService.currentTab == 'PrivateFolder') && this.universalService.foldersArray.length==0 && !this.universalService.openFolderContent)|| this.universalService.currentTab != 'PrivateFolder' && this.universalService.currentTab != 'allfiles' && this.universalService.currentTab != 'teamfolders' && this.universalService.currentTab != "tftrash"){
        this.universalService.emptyTab = true;
        this.universalService.reBindingRequied  =true;
      } else if (this.universalService.openFolderContent && this.universalService.foldersArray.length ==0 && this.universalService.currentTab == 'allfiles'){
        this.universalService.emptyFolder = true;
      } else if (this.universalService.openFolderContent && this.universalService.foldersArray.length ==0 && this.universalService.currentTab == 'teamfolders'){
        this.universalService.emptyFolder = true;
      } else if (this.universalService.openFolderContent && this.universalService.foldersArray.length ==0 && this.universalService.currentTab == 'PrivateFolder'){
        this.universalService.emptyFolder = true;
      }else if (this.universalService.foldersArray.length ==0 && (this.universalService.currentTab == 'docs'||this.universalService.currentTab == 'audio'||this.universalService.currentTab == 'videos'||this.universalService.currentTab == 'photos')){
        this.universalService.emptyFolder = true;
      }
    }
      // this is to remove the object from preview files array also
      var checkIndex = sortedArray.find(obj=>obj["objectKey"] == object["objectKey"]);
      if(checkIndex)
      indexInPreviewArray = this.universalService.recentFilesPreviewArray.indexOf(checkIndex);
      if(indexInPreviewArray>=0){
        this.universalService.recentFilesPreviewArray.splice(indexInPreviewArray,1)
      }
    })
    if(executedTask == 'MOVETOPF')
        this.addToDBForMoveCopy(null, executedTask)
    if(executedTask == 'MOVETOPF' && this.universalService.selectedTab == "Home" && this.memoryImplementation.memoriesList.length > 0) {
      AppEvents.memorySubscriptions.next({reinvokememory:true});
    }
    this.listService.deSelectAll(null);
    if(this.universalService.showPreview  && (executedTask=='TRASH' || executedTask=='MOVETOPF' || (this.universalService.currentTab == "PrivateFolder" && executedTask=='MOVE' ) || this.universalService.currentTab == 'allfiles' || this.universalService.currentTab == "DigiLocker")){
      this.previewImplementation.deleteORMoveObject(executedTask);
    }

    return sortedArray
  }
  
  
  updateOnlyTheUI(sortedArray,list,executedTask){
    list.map(object=>{
      var foldersArray;
      object = object["FullObject"]?object["FullObject"]:object;
      let md=undefined;
      if(this.universalService.updatedObject!=undefined && this.universalService.updatedObject!=null && executedTask != "FRN") {
        md = new Date(this.universalService.updatedObject.objects[0].object.lastModifiedDate);
      } else if (this.universalService.updatedObject == null && (this.universalService.currentTab == 'sharedFiles' || this.universalService.currentTab == 'teamfolders')){
        var lastModifiedDate = new Date().getTime();
        md = new Date(lastModifiedDate);
      }
      if(executedTask == "RENAME" && object["objectType"]=='FR'){
        foldersArray = this.universalService.foldersArray
        var find = foldersArray.find(obj=>obj["objectKey"] == object["objectKey"]);
        if(find){
          var index = foldersArray.indexOf(find);  //find the index of object in the folders array
          if(index>=0){
            foldersArray[index]["objectName"] = object["objectName"];
            foldersArray[index]["modifiedOn"] = this.weekDays[md.getDay()] + ", " + md.getDate() + " " + this.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();
          }
        }
        this.universalService.updatedObject = undefined
      }else if(this.universalService.selectedTab == "Album Details"){
        this.updateOnlyTheUIWithoutMonthWiseSegregation(sortedArray,list,executedTask)
      }
      else{
        sortedArray.map(month=>{ // traverse through each month to find the object
          md = new Date(new Date().getTime());
          var indexInSortArray;
          var objects = month["objects"]
          var find = objects.find(obj=>obj["objectKey"] == object["objectKey"]);
          if(find)
          indexInSortArray = objects.indexOf(find);  //find the index of object in the month
  
          if(indexInSortArray >=0){
            if(executedTask == 'SETFAV'){ // if user has favorited the file
              // if(objects[indexInSortArray]['isFavorite'] == true) { // It was updating for all objects even though some got failed/unprocessed.
                objects[indexInSortArray]['isFavorite'] = true;
              // }
            }else if (executedTask == "UNSETFAV"){// if user has unmarked file as favorite
              if(this.universalService.currentTab == 'Favorites'){
                this.updateSummaryCountsAndUI(sortedArray,list,executedTask);
                if(this.universalService.showPreview == true){
                  // this.previewImplementation.fetchNext();
                  AppEvents.optionSelected.next({'unFavFromFavPreview':true})
                }
              }else{
                objects[indexInSortArray]['isFavorite'] = false;
              }
            }else if (executedTask == "RENAME" || executedTask == "FRN"){  // if the user has renamed the file
              if(this.universalService.fetchAllRecentFiles){
                sortedArray[0]['objects'].splice(indexInSortArray,1);
                sortedArray[0]['objects'] = list.concat(sortedArray[0]['objects']);
                objects = sortedArray[0]['objects'];
                indexInSortArray = objects.indexOf(find);
              }
              
                // objects[indexInSortArray]["objectName"] = object["objectName"];
                if(!this.router.url.includes('/teamfolder')) {
                  objects[indexInSortArray]["objectName"] = this.universalService.updatedObject ? this.universalService.updatedObject["objects"][0]["object"]["objectName"] : object["objectName"];
                }
                var extns = object["objectName"].split(".");
                if (this.universalService.isMobileDevice) {
                  if (object["objectName"].length > 14) {
                    objects[indexInSortArray]["objectShortName"] = object["objectName"].slice(0, 8) + "..." + extns[extns.length - 1];
                  } else {
                    objects[indexInSortArray]["objectShortName"] = object["objectName"];
                  }
                } else {
                  if (object["objectName"].length > 20) {
                    objects[indexInSortArray]["objectShortName"] = object["objectName"].slice(0, 14) + "..." + extns[extns.length - 1];
                    objects[indexInSortArray]["objectDragName"] = object["objectName"].slice(0, 20) + "...";
                  } else {
                    objects[indexInSortArray]["objectShortName"] = object["objectName"];
                    objects[indexInSortArray]["objectDragName"] = object["objectName"];
                  }
                }

                if (object["objectName"].length > 20) {//show name irrespective of mobile which holds 8 & desktop hold 20 in 'objectShortName'
                  objects[indexInSortArray]["trimmedObjectName"] = object["objectName"].slice(0, 17) + "..." + (extns.length>0?extns[extns.length - 1]:"")
                } else {
                  objects[indexInSortArray]["trimmedObjectName"] = object["objectName"];
                }
                if(executedTask!="SHAREPERMISSION")
                  objects[indexInSortArray]["modifiedOn"] = this.weekDays[md.getDay()] + ", " + md.getDate() + " " + this.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();
                if(this.universalService.showPreview){
                  this.previewImplementation.fileForPreview["objectShortName"] = objects[indexInSortArray]["objectShortName"]
                  this.previewImplementation.fileForPreview["modifiedOn"] = this.weekDays[md.getDay()] + ", " + md.getDate() + " " + this.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();
             
                }
                this.universalService.updatedObject = undefined
            } else if (executedTask == "SHAREPERMISSION") {
              objects[indexInSortArray]["isShared"] = object["isShared"];
              objects[indexInSortArray]["shareType"] = object["shareType"];
            }
          }
          if(indexInSortArray >= 0 ){
            if(objects.length>0 && (executedTask == "RENAME" || executedTask == "FRN")){
              objects[indexInSortArray]["modifiedOn"] = this.weekDays[md.getDay()] + ", " + md.getDate() + " " + this.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();
              objects[indexInSortArray]["lastModifiedDate"] = new Date().getTime();
              objects[indexInSortArray]["lastUpdatedTime"] = new Date().getTime();
            }
          }
        })
        if(this.universalService.showPreview  && executedTask=='RENAME'){
          var extns = object["objectName"].split(".");
          this.universalService.selectedFile.objectName=object["objectName"]
          this.universalService.selectedFile.modifiedOn=  this.weekDays[md.getDay()] + ", " + md.getDate() + " " + this.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();


          if (this.universalService.isMobileDevice && object["objectName"].length > 14){
            this.universalService.selectedFile.objectShortName = object["objectName"].slice(0, 8) + "..." + extns[extns.length - 1];
          }else if (!this.universalService.isMobileDevice && object["objectName"].length > 20){
            this.universalService.selectedFile.objectShortName = object["objectName"].slice(0, 14) + "..." + extns[extns.length - 1];
          }else{
            this.universalService.selectedFile.objectShortName = object["objectName"]
          }
        }
      }
    })
    if(list.length == 1){
      this.universalService.selectedFile = list[0];
    }
    this.listService.deSelectAll(null);
    return sortedArray;
  }


  returnTheListOfUpdatedObjectsForVirtualGrid(list,sortedArray){
    let monthWiseSegregation = this.checkIfSortedArrayHasMonthWiseSegregation(sortedArray);
    if(monthWiseSegregation){
      list.map((object,index)=>{
        sortedArray.map(month=>{
          var objects = month["objects"];
          var find = objects.find(obj=>obj["objectKey"] == object["objectKey"]);
          if(find){
            object = {...object,...find};
            list[index] = object;
          }
        })
      })
    }else{
      list.map((object,index)=>{
        var find = sortedArray.find(obj=>obj["objectKey"] == object["objectKey"]);
        if(find){
          object = {...object,...find};
          list[index] = object;
        }
      })
    }
    return list;
  }

  checkIfSortedArrayHasMonthWiseSegregation(sortedArray){
    if(sortedArray[0] && sortedArray[0]["objects"]){
      return true
    }
    return false
  }


  updateSummaryCounts(url,tab,fetchFolderData){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(url).subscribe(
        suc=>{
          self.updateCounts(suc,tab,fetchFolderData);
          resolve(suc);
        },
        err=>{
          reject(err);
        }
      )
    })
  }


  updateCounts(resp,tab,fetchFolderData){
    var summary = [];
    if(resp["folders"]){
      this.universalService.totalCountOfFolders = resp["folders"][0]["fileCount"]
    }
    if(fetchFolderData){
      if(!this.universalService.fetchAllRecentFiles){
        summary = resp["all"]?resp["all"]:[];
        this.universalService.sharedRoot = this.mapMonthFileCounts(this.universalService.sharedRoot, summary)
      }
      return;
    }
    switch(tab){
      case 'allfiles':
        if(!this.universalService.fetchAllRecentFiles){
          summary = resp["all"]?resp["all"]:[];
          this.universalService.sharedRoot = this.mapMonthFileCounts(this.universalService.sharedRoot, summary)
        }
        break;

      case 'photos':
        summary = resp["image"]?resp["image"]:[];
        this.universalService.sharedImages = this.mapMonthFileCounts(this.universalService.sharedImages, summary)
        break;

      case 'audio':
        summary = resp["audio"]?resp["audio"]:[];
        this.universalService.sharedAudios = this.mapMonthFileCounts(this.universalService.sharedAudios, summary)
      break;

      case 'videos':
        summary = resp["video"]?resp["video"]:[]
        this.universalService.sharedVideos = this.mapMonthFileCounts(this.universalService.sharedVideos, summary);
        break;

      case 'docs':
        summary = resp["others"]?resp["others"]:[];
        this.universalService.sharedDocs = this.mapMonthFileCounts(this.universalService.sharedDocs, summary)
        break;

    }
  }


  mapMonthFileCounts(summaryTabArr, summary) {

    if (summary.length == 0) {
      this.universalService.emptyTab = true;
      return summary;
    }

    summary.map(m => {
      let month = summaryTabArr.find(obj => {
        return obj["month"] == m["month"]
      })
      if (month) {
        month["fileCount"] = m["fileCount"]
      } else {
        summaryTabArr.push(m);
      }
    })
    return summaryTabArr;


  }

  togglePreviewButtons(){
    this.previewImplementation.togglePreviewButtons();
  }
  
  openFolder(folder) {
    this.listService.cellclick = false;
    if (this.universalService.showTopMenu && this.universalService.selectedNodes.length > 1)
      return;
    if (this.universalService.showTopMenu && this.universalService.selectedNodes.length == 1 &&
      this.universalService.selectedNodes[0].objectKey != folder.objectKey)
      return;

    this.universalService.isServerError = false;
    if (folder.parentObjectName == 'Root Folder' || this.folderService.breadCrumbsList.length == 1) {
      this.universalService.selectedFile = folder;
      this.universalService.openFolderContent = true;
      this.universalService.insideFolder = true;
      setTimeout(() => {
        this.universalService.showTopMenu = false;
        this.universalService.hideTopMenuOptions();  
      }, 100)
      return true;
    } else {
      this.universalService.selectedFile = folder;
      this.universalService.showTopMenu = false;
      this.universalService.hideTopMenuOptions();  
      this.universalService.openFolderContent = true;
      this.universalService.insideFolder = true;
      this.folderService.clickedFolderName = folder.objectName;
      this.folderService.manageBreadCrumbs(folder.objectKey, folder.objectName, folder);
      this.universalService.foldersArray = [];
      return false;
    }
  }

updateOnlyTheUIWithoutMonthWiseSegregation(sortedArray,list,executedTask){
  let md=undefined;
  md = new Date(new Date().getTime())
  list.map(object=>{
    if(object["objectType"]=='FR' && executedTask == "TRASH"){
      let foldersArray = this.universalService.foldersArray
      var find = foldersArray.find(obj=>obj["objectKey"] == object["objectKey"]);
      if(find){
        var index = foldersArray.indexOf(find);  //find the index of object in the folders array
        if(index>=0){
          foldersArray.splice(index,1)
          this.universalService.totalCountOfFolders = foldersArray.length
          if(this.universalService.isMobileDevice){
            var find = this.universalService.mobileSelectedObj.find(obj=>obj["objectKey"] == object["objectKey"]);
            var indexInmobileSelectedObj = this.universalService.mobileSelectedObj.indexOf(find);
            if(indexInmobileSelectedObj>=0)
              this.universalService.mobileSelectedObj.splice(indexInmobileSelectedObj,1);
          }
        }
      }
    }else{
    object = object["FullObject"]?object["FullObject"]:object;
    var find = sortedArray.find(obj=>obj["objectKey"] == object["objectKey"]);
    var indexInSortArray;
    if(find){
        indexInSortArray = sortedArray.indexOf(find);
    }
    if(executedTask == "RENAME" || executedTask == "FRN"){
        sortedArray[indexInSortArray]["objectName"] = object["objectName"];
        var extns = object["objectName"].split(".");
        if (this.universalService.isMobileDevice) {
          if (object["objectName"].length > 14) {
            sortedArray[indexInSortArray]["objectShortName"] = object["objectName"].slice(0, 8) + "..." + extns[extns.length - 1];
          } else {
            sortedArray[indexInSortArray]["objectShortName"] = object["objectName"]
          }
        } else {
          if (sortedArray[indexInSortArray]["objectName"].length > 20) {
            sortedArray[indexInSortArray]["objectShortName"] = object["objectName"].slice(0, 14) + "..." + extns[extns.length - 1];
          } else {
            sortedArray[indexInSortArray]["objectShortName"] = object["objectName"]
          }
        }
        
        if(this.universalService.showPreview){
          this.previewImplementation.fileForPreview["objectShortName"] = sortedArray[indexInSortArray]["objectShortName"]
          this.previewImplementation.fileForPreview["modifiedOn"] = this.weekDays[md.getDay()] + ", " + md.getDate() + " " + this.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();
        }
    }else if(executedTask == 'SETFAV'){ // if user has favorited the file
      sortedArray[indexInSortArray]['isFavorite'] = true;
    }else if (executedTask == "UNSETFAV"){// if user has unmarked file as favorite
      sortedArray[indexInSortArray]['isFavorite'] = false;
    }else if(((executedTask == "FTR" && !this.universalService.showPreview) || executedTask == "TRASH") ){
      sortedArray.splice(indexInSortArray,1);
      if(sortedArray.length == 0) {
        // this.universalService.emptyTab = true;
        indexInSortArray = undefined
      }
    }
    if(indexInSortArray >= 0 && indexInSortArray<sortedArray.length){
      sortedArray[indexInSortArray]["modifiedOn"] = this.weekDays[md.getDay()] + ", " + md.getDate() + " " + this.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();
      sortedArray[indexInSortArray]["lastModifiedDate"] = new Date().getTime();
      sortedArray[indexInSortArray]["lastUpdatedTime"] = new Date().getTime();
    }
  }
  })
  this.listService.deSelectAll(null);
  if(this.universalService.showPreview  && (executedTask=='FTR' || executedTask=='TRASH')){
    this.previewImplementation.deleteORMoveObject(executedTask);
  }
  return sortedArray;
}

switchTab(tabName) {
  var tab = this.sessionStorageService.getCurrentTabName();
  if ((tab == 'allfiles' && this.universalService.openFolderContent) || ((tab == 'allfiles' && !this.universalService.openFolderContent) || tab != 'allfiles') && tab != tabName) {
    this.listService.headerCheckBoxChecked = false;
    this.listService.disableSelectionModeInListView = false;
    this.listService.deselectedNodesArray = [];
    if(this.universalService.activeRepo == "main" && !(localStorage.sharePublicSort == this.universalService.sharePublicSortByUploadDate)){
      let temp =  this.listService.listViewSortOrder
      if(tabName == 'allfiles' && (temp.includes("createdDate") || temp.includes("fileCreatedDate")  || temp.includes("size") ||temp.includes("Name"))  )
        this.listService.listViewSortOrder = temp;
      else if(tabName == 'audio' && (temp.includes("createdDate") || temp.includes("fileCreatedDate") || temp.includes("Name"))  )
        this.listService.listViewSortOrder = temp;
      else if(tabName == 'docs' && (temp.includes("createdDate") || temp.includes("fileCreatedDate") || temp.includes("size")||temp.includes("Name"))  )
        this.listService.listViewSortOrder = temp;
      else 
        this.listService.listViewSortOrder = "&sort=%2DfileCreatedDate";
      localStorage.setItem('listViewSortOrder',this.listService.listViewSortOrder);
    }else { 
        let temp =  this.listService.listViewSortOrder
        if(this.universalService.activeRepo == "share" && tabName == 'allfiles' && (temp.includes("createdDate")   || temp.includes("size") ||temp.includes("Name"))  )
          this.listService.listViewSortOrder = temp;
        else if(this.universalService.activeRepo == "share" && tabName == 'audio' && (temp.includes("createdDate") || temp.includes("Name"))  )
          this.listService.listViewSortOrder = temp;
        else if(this.universalService.activeRepo == "share" && tabName == 'docs' && (temp.includes("createdDate") ||  temp.includes("size")||temp.includes("Name"))  )
          this.listService.listViewSortOrder = temp;
        else 
          this.listService.listViewSortOrder = "&sort=%2DcreatedDate";
        localStorage.setItem('listViewSortOrder',this.listService.listViewSortOrder);    
    }
    this.listService.idsArray = [];
    this.listService.sortType = "asc"
    this.universalService.showLoader = false;
    this.universalService.isServerError = false;
    this.rootFolderCheck = false;
    this.universalService.showJustifiedLayout = false;
    this.universalService.recentFilesListView = false;
    this.universalService.fetchAllRecentFiles = false;
    this.universalService.openMoreOptions = false;
    this.universalService.uploadButtonClicked = false;
    this.universalService.emptyTab = false;
    this.universalService.emptyFolder = false;
    this.universalService.emptyTrash = false;
    this.universalService.emptyFav = false;
    if (this.folderService.breadCrumbsList.length > 1 ) { //&& tabName == 'allfiles' check removed because the breadcrumbs are not disappearing when switching tab
      this.rootFolderCheck = true;
      this.folderService.openFolderFromBreadCrumb(this.folderService.breadCrumbsList[0].objectKey);
      this.universalService.openFolderContent = false;
      this.universalService.insideFolder = false;
      this.folderService.clickedFolderName = this.folderService.currentFolderName;
      this.sessionStorageService.removeSessionProperty(SessionStorageProps.CURRENT_FOLDER_KEY);
      this.folderService.manageBreadCrumbs(this.folderService.currentFolderKey, this.folderService.currentFolderName, this.folderService.currentFolder);
      this.universalService.foldersArray = [];
      // this.homeController.fetchSummary();
      jQuery("#customContextMenu").hide();
    }
    this.sessionStorageService.removeSessionProperty(SessionStorageProps.CURRENT_FOLDER_KEY);
    this.universalService.mobileSelectionModeOn = false;
    this.universalService.isDesktopSelectionModeOn = false;
    this.universalService.mobileSelectedObj = [];
    this.universalService.objectsPreviewArray = [];
    this.universalService.selectedNodes = [];
    this.contextMenuService.hideCustomContextMenu();
    this.universalService.showTopMenu = false;
    this.universalService.hideTopMenuOptions();
    this.universalService.scrollToTopIcon = false;
    this.listService.audiosRowDataSet = false;
    this.previousTab = this.universalService.currentTab;
    this.listService.docsRowDataSet = false;
    this.universalService.currentTab = tabName;
    this.sessionStorageService.setCurrentTabName(this.universalService.currentTab)
    this.listService.cellclick = false;
    this.universalService.popUpToBeOpened = "";
    this.universalService.showAddToJioCloudOnTopMenu = true;
    this.universalService.showFileInfo = false;
    // if ( !this.universalService.openFolderContent && this.universalService.currentTab == 'allfiles' && (this.universalService.sharedImages.length != 0 || this.universalService.sharedVideos.length != 0) && this.universalService.sharedAudios.length == 0 && this.universalService.sharedDocs.length == 0) {
    //   this.universalService.showJustifiedLayout = true;
    // } else {
    //   this.universalService.showJustifiedLayout = false;
    // }
    if (this.universalService.currentTab == "audio") {
      this.universalService.listView = true;
      this.universalService.showSortButtons = false;
    }
    if (this.universalService.currentTab == "docs") {
      this.universalService.listView = true;
      this.universalService.showSortButtons = false;
    }
    if (this.universalService.currentTab == 'allfiles') {
      this.universalService.showSortButtons = true;
    }
    if (this.universalService.currentTab == "photos") {
      this.universalService.listView = false;
      this.universalService.showSortButtons = true;
    }
    if (this.universalService.currentTab == "videos") {
      this.universalService.listView = false;
      this.universalService.showSortButtons = true;
    }
    if (this.universalService.selectedTab == "TeamsFolderOperations") {
      this.universalService.listView = false;
      this.universalService.showSortButtons = false;
    }
  }
}

  checkStorageAfterDeletingFiles(resp){
      var usedSpace = resp.usedSpace;
      var allocatedSpace = USER_DETAILS["USER_DETAILS"]["quota"]["totalAllocatedQuota"]
      var availableSpace = parseInt(allocatedSpace) - parseInt(usedSpace);
      var userData = this.localStorageService.getUserData(true);
      if(userData && userData["quota"]){
        resp["usedSpace"] = resp["usedSpace"] == 0 ? 0 : (resp["usedSpace"] ? resp["usedSpace"] : userData["quota"]["totalUsedQuota"]);
        userData["quota"]["totalUsedQuota"] = resp["usedSpace"];
        AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,updateStorageRepresentationOnUI:true});
      }
      if(availableSpace <= 19585531){
        // localStorage.removeItem("showStorageBanner");
        BANNER_CONSTANTS.STORAGE_BANNER["forceShow"] = true;
        AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);
		  }else{
        AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);  
      }
  }

  checkIfCoverPicIsDeleted(resp){
    if(resp.objects){
      var objs = resp.objects;
      objs.forEach(d => {
        if(d.object && d.object.objectKey && d.object.objectKey == this.universalService.currentAlbum.boardCoverPicObjectKey){
          //one of removed files was cover pic file, therefore deleting this property from current album
          delete this.universalService.currentAlbum["boardCoverPic"];
          return;
        } 
      })
    }
  }


  public setPayloadForPrivateFolderObjectOperations(files, operation,correlationId) {


    var objectsArray = [];
    var payload = [];
    if (Array.isArray(files)) {
      objectsArray = files
    } else {
      objectsArray.push(files)
    }

    if (operation == "TRASH") {
      objectsArray.map(obj => {
        var object;
        if (obj["FullObject"]) {
          object = obj["FullObject"]
        } else {
          object = obj
        }
        payload.push(object.objectKey)
      })
    } else if (operation == "RENAME") {
      objectsArray.map(obj => {
        var object;
        if (obj["FullObject"]) {
          object = obj["FullObject"]
        } else {
          object = obj
        }
        payload.push({
          "parentObjectKey": object.parentObjectKey,
          "objectKey": object.objectKey,
          "objectName": object.objectName
        })
      })
    }else{
      objectsArray.map(obj=>{
        var object;
        if(obj["FullObject"]){
          object = obj["FullObject"]
        }else{
          object = obj
        }
        payload.push({
          "correlationId":correlationId,
          "object":object,
          "operation":operation
        })
      })

    }
    return payload;
  }

  renamePFObject(url,payload,files){
    var self = this;
    var params : any;
    params = payload[0]
    return new Promise(async function (resolve, reject) {
      self.http.put(url,params).subscribe(
      renameResponse =>{ 
        if(renameResponse != null && renameResponse["unprocessed"] && renameResponse["unprocessed"].length != 0){// if any files are under the unprocessed array
          self.universalService.showLoader = false;
          if(renameResponse.unprocessed[0].object.errorCode == "NMSOM0064"){
            if(self.universalService.selectedFile.objectType == 'FE'){
              self.universalService.showToast(TOAST["FILENAME_EXISTS"], "error");
            }
            else{
              self.universalService.showToast(TOAST["FOLDERNAME_EXISTS"], "error");
            }
          }
          else self.universalService.showToast(renameResponse.unprocessed[0].object.errorMessage, "error");
          self.universalService.selectedFile["objectName"] = self.universalService.selectedFileOldName;
        } else {
          self.universalService.updatedObject =  renameResponse; 
          self.loggerService.log("renamed successfully",renameResponse);
          resolve("renamed successfully")
        }
      },
      err=>{
        self.universalService.selectedFile["objectName"] = self.universalService.selectedFileOldName;
        self.loggerService.log(" error in renameing the selected file",err);
        self.universalService.selectedFile["objectName"] = self.universalService.selectedFileOldName;
        self.universalService.showErrorMessage(err)
        //reject(err);
      }
      )
    })
  }

  deletePFObjects(url,payload,files){ 
    var self = this;
    var params = {
      objectKeys:payload
    }
    return new Promise(async function (resolve, reject) {
    self.http.put(url,params).subscribe(
      deleteResponse =>{
        self.checkStorageAfterDeletingFiles(deleteResponse);
        resolve("deleted successfully")
      },
      err=>{
        self.loggerService.log(" error in deleting the selected file",err);
        self.universalService.showLoader = false;
        if (err["error"].unprocessed[0]["errorCode"] == "NMSCL0024") {
          self.universalService.showToast(TOAST["FILE_DOES_NOT_EXIST"], "error");   
        } else if (err["error"].unprocessed[0]["errorCode"] == "NMSCL0021") {
          self.universalService.showToast(err["error"].unprocessed[0]["errorMessage"], "error");
        }
        reject(err);
      }
    )
  })
  }
}
